import typeCheckingStore from "data/util/typeCheckingStore";
import Dispatcher from "Dispatcher";
import { ReduceStore } from "flux/utils";
import DefineActions from "jsmodel/DefineActions";
import PropTypes from "prop-types";
import entityMetaStore from "data/meta/entityMetaStore";
import userStore from "data/userStore";

export const loadTableIntoState = (state, info) => {
    const allowByDefault = userStore.getState().isEmpty();
    return ({
        ...state,
        [info.key]: {
            canCreate: allowByDefault,
            canWrite: allowByDefault,
            canDelete: allowByDefault,
        },
    });
};

export const loadEntityIntoState = (state, entityKey) => {
    if (userStore.getState().isEmpty()) return state;
    const info = entityMetaStore.getInfo(entityKey);
    const tableKey = info.tableKey;
    return {
        ...state,
        [tableKey]: {
            canCreate: state[tableKey].canCreate || info.canCreate,
            canWrite: state[tableKey].canWrite || info.canWrite,
            canDelete: state[tableKey].canDelete || info.canDelete,
        },
    };
};

class TableMetaStore extends ReduceStore {

    getInitialState() {
        return {};
    }

    reduce(state, action) {
        switch (action.type) {

            case DefineActions._UNLOAD:
                return this.getInitialState();

            case DefineActions.TABLE:
                return loadTableIntoState(state, action.def);

            case DefineActions.ENTITY:
                this.__dispatcher.waitFor([
                    entityMetaStore.getDispatchToken(),
                ]);
                return loadEntityIntoState(state, action.key);

            default:
                return state;
        }
    }

    _getInfo(key) {
        const s = this.getState();
        if (!s.hasOwnProperty(key)) {
            throw new Error(`No '${key}' table is known.`);
        }
        return s[key];
    }

    canCreate(key) {
        return this._getInfo(key).canCreate;
    }

    canWrite(key) {
        return this._getInfo(key).canWrite;
    }

    canDelete(key) {
        return this._getInfo(key).canDelete;
    }

}

TableMetaStore.stateTypes = PropTypes.objectOf(
    PropTypes.shape({
        canCreate: PropTypes.bool.isRequired,
        canWrite: PropTypes.bool.isRequired,
        canDelete: PropTypes.bool.isRequired,
    })
);

export default typeCheckingStore(new TableMetaStore(Dispatcher));



// WEBPACK FOOTER //
// ./app/data/meta/TableMetaStore.js